<template>
  <call-session-user
    class="h-full relative aspect-4/3! w-full"
    :room-p-served="roomPServed"
    :contact="contact"
    :session="session!"
    :selected-contact-id="selectedContactId!"
    :selected-stream-id="selectedStreamId!"
    @select="onSelect"
  >
    <template #indicator>
      <slot name="indicator" />
    </template>
    <template #action>
      <button
        class="hover:opacity-50 bg-black/25! p-1 rounded-4 flex shrink-0 text-white right-0 absolute top-0 z-10"
        @click.stop="toggle"
      >
        <span class="sr-only select-none">{{ $t('common.openMenu') }}</span>
        <wui-icon
          name="kebabHorizontalM"
        />
      </button>
    </template>
    <template #footer="{ contactName, videoActive, title, count }">
      <footer
        class="absolute bottom-0 text-center z-8 overflow-hidden left-1/2 -translate-x-1/2 w-full rounded-8 px-2 text-white bg-black text-label-r-13-16"
        :class="{'bg-black/50!' : videoActive}"
        :title="title"
      >
        <name-with-user-agent
          :name="contactName"
          :user-agent="contact.userAgent"
          :count="count"
        />
      </footer>
    </template>
  </call-session-user>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { PServed } from '@wui/im'

import { ConferenceParticipant } from '@/entities/conference-participant'
import { CallSessionUser } from '@/entities/contact'
import { RTCSessionFacade } from '@/entities/webrtc'

import { NameWithUserAgent } from '@/shared/components/user-agent-icon'

defineProps<{
  contact: ConferenceParticipant
  selectedContactId?: string
  selectedStreamId?: string
  roomPServed: PServed
  session?: RTCSessionFacade
}>()

const emit = defineEmits<{
  (event: 'select', contactId: string, stream?: MediaStream): void
  (event: 'configure'): void
}>()

const toggle = () => emit('configure')

const onSelect = (contactId: string, stream?: MediaStream) => {
  emit('select', contactId, stream)
}
</script>
